import {
	defaultTqcInspectResultDtlDto,
	TqcInspectResultDtlDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";

/**
 * TQC2090_R01 초중종검사 결과등록(JC) 그리드 행 DTO.
 *
 * 아연라인은 1행이 검사결과 상세 1건이다.
 * 니켈크롬라인은 외관·도금두께 상세 2건을 날짜별 화면 행 1건으로 결합한다.
 * 상속받은 검사값 15칸이 화면의 초품/중품/종품 × 값1~값5 다.
 *
 * - 초품 값1~값5 → inspectValue1_1 ~ 1_5
 * - 중품 값1~값5 → inspectValue2_1 ~ 2_5
 * - 종품 값1~값5 → inspectValue3_1 ~ 3_5
 *
 * 검사기준의 inspItemCd와 저장 상세의 itemCd는
 * tqc_inspect_spec.insp_item_cd = tqc_inspect_result_dtl.item_cd 관계다.
 */
export interface TQC2090_R01Dto extends TqcInspectResultDtlDto {
	// 검사결과 헤더 필드
	compCd: string;
	workplaceCd: string;
	inspectType: string;
	inspectorEmp: string;
	inspectorEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;

	// 화면 전용 표시 필드
	/** 일자 (1~31) */
	dayOfMonth: number;
	/** 요일 (월~일) */
	dayOfWeekNm: string;
	/** 검사항목명 */
	inspItemNm: string;
	/** 검사기준 항목코드 */
	inspItemCd: string;
	/** 검사기준 구분 (FML_NI/FML_CR) */
	specInspType: string;
	/** 기준값 표시문자열 (예: "10mm 이상") */
	specText: string;
	/** 검사값유형 (숫자 / 문자 / OK.NG) */
	valueType: string;

	// 니켈크롬라인 도금두께 표시용 필드
	thicknessInspItemCd: string;
	thicknessItemNm: string;
	thicknessSpecText: string;
	thicknessValueType: string;
	thicknessInspectNo: string;
	thicknessItemNo: string;
	thicknessFirstValue: string;
	thicknessMiddleValue: string;
	thicknessLastValue: string;

	// 그리드 상태 (화면 전용 — 서버로 보내도 무시된다)
	inserted: boolean;
	isModified: boolean;
}

export const defaultTQC2090_R01Dto: TQC2090_R01Dto = {
	...defaultTqcInspectResultDtlDto,
	compCd: "",
	workplaceCd: "",
	inspectType: "",
	inspectorEmp: "",
	inspectorEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	dayOfMonth: 0,
	dayOfWeekNm: "",
	inspItemNm: "",
	inspItemCd: "",
	specInspType: "",
	specText: "",
	valueType: "",
	thicknessInspItemCd: "",
	thicknessItemNm: "",
	thicknessSpecText: "",
	thicknessValueType: "",
	thicknessInspectNo: "",
	thicknessItemNo: "",
	thicknessFirstValue: "",
	thicknessMiddleValue: "",
	thicknessLastValue: "",
	inserted: false,
	isModified: false,
};

/** 공정라인. 마스터 조회 없이 화면에 고정한다. (설계 문서 §4) */
export const TQC2090_R01_LINE_OPTIONS = [
	{ workplaceCd: "NI", workplaceNm: "아연라인" },
	{ workplaceCd: "CR", workplaceNm: "니켈크롬라인" },
] as const;

/** 검사구분 - 초중종검사 (INSPECTION_TYPE 공통코드) */
export const TQC2090_R01_INSPECT_TYPE = "FML";
export const TQC2090_R01_COMP_CD = "1000";

/** 검사값 컬럼. 그룹별 5회차씩 15칸이다. */
export const TQC2090_R01_VALUE_FIELDS = [
	"inspectValue1_1", "inspectValue1_2", "inspectValue1_3", "inspectValue1_4", "inspectValue1_5",
	"inspectValue2_1", "inspectValue2_2", "inspectValue2_3", "inspectValue2_4", "inspectValue2_5",
	"inspectValue3_1", "inspectValue3_2", "inspectValue3_3", "inspectValue3_4", "inspectValue3_5",
] as const;
